<script>
	// Stores 
	import { 
		textSite, 
		textAtendimento, 
		textAtendimentoVendas, 
		textEndereco, 
		textTelefone, 
		textWhatsappVendas, 
		linkTelefone, 
		linkWhatsappVendas, 
		linkWaze, 
		linkUber, 
		linkMapa,
		linkIframeMapa

	} from '../store.js'; 

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Onde Estamos ';

	let contatos = [
		{   
			name: 'Atendimento',
			link: $linkTelefone,
			text: $textTelefone,
			icon: '<i class="fas color-primary fa-phone"></i>'
		},
		{   
			name: 'Plantão de Vendas',
			link: $linkWhatsappVendas,
			text: $textWhatsappVendas,
			icon: '<i class="fab color-primary fa-whatsapp"></i>'
		}
	];    

	let localizacao = [
		{
			title: 'Mapa',
			icon: '<i class="fas fa-map-marked-alt color-primary"></i>',
			link: $linkMapa,
		},
		{
			title: 'Waze',
			icon: '<i class="fab fa-waze color-primary"></i>',
			link: $linkWaze,
		},
		{
			title: 'Uber',
			icon: '<i class="fab fa-uber color-primary"></i>',
			link: $linkUber,
		}
	];    

</script>

<section class="localizacao">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container">    
		<p>Confira a nossa localização e venha nos fazer uma visita.</p>
		<div class="itens mb-30 mt-30">
			<div class="item row align-items-center">
				<div class="col-lg-7 ml-10">
					<p>
						<a class="color-primary text-uppercase" href="{$linkTelefone}" title="Contato via Telefone Atendimento - {$textSite}" target="_blank">
							<i class="fas fa-phone"></i> Atendimento <b>{$textTelefone}</b>
						</a> 
						<br>{@html $textAtendimento}
					</p>
					<p>
						<a class="color-primary text-uppercase" href="{$linkWhatsappVendas}" title="Contato via WhatsApp Plantão de Vendas - {$textSite}" target="_blank">
							<i class="fab fa-whatsapp"></i> Plantão de Vendas <b>{$textWhatsappVendas}</b>
						</a> 
						<br>{@html $textAtendimentoVendas}
					</p>
					<h2 class="color-primary text-uppercase mb-10 mt-20"><b>Endereço</b></h2>
					<p>{@html $textEndereco}</p>		
					<ul class="list list--point-destaque">
					{#each localizacao as item}
						<li class="list-item">
							<a href="{item.link}" target="_blank" title="{item.title} - {$textSite}">
								{@html item.icon} {item.title} 
							</a>
						</li>
					{/each}
					</ul>
				</div>
				<div class="col-lg-4 image">
					<a href="/sobre" title="Clique aqui para saber mais sobre ${textSite}">
						<iframe class="loading-img" src="{$linkIframeMapa}" height="400" width="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
					</a>
				</div>
			</div>
		</div> 
	</div>
</section>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

=before-bg($width, $height, $widthM, $heightM)
	content: ""
	height: $height
	width: $width
	position: absolute
	margin: auto 	
	+media-breakpoint-up(lg)
		height: $height
		width: $width	
	+media-breakpoint-down(md)	
		height: $heightM
		width: $widthM	

h2
	color: #000
	font-size: $font-text

a
	color: $color-font-primary

section.localizacao .itens
	.item 
		text-align: center
		position: relative
		&:before 
			+before-bg(100%, 86%, 100%, 80%)
			background-color: $color-bg
			z-index: -1
			bottom: 0	
		.image 
			iframe
				border-radius: 10px
	.item, .item p
		font-size: $font-text

+media-breakpoint-up(lg)
	section.localizacao .itens .item 
		&:nth-child(even)
			flex-direction: row-reverse	
		&:before 
			top: 0					
		.image 
			img 
				height: 400px
				
+media-breakpoint-down(md)
	section.localizacao 
		.itens .item 
			flex-direction: column-reverse
			padding: 10px
			.column 
				margin: 0 0 15px
				&.image 
					img 
						margin: 0 auto 10px

</style>